import { TermScheduleFlags } from '../services/term_schedule_flags';
import { ScheduledSectionServant } from '../servants/scheduled_section_servant';
import { Section } from '../../sections/builders/section_builder';
import { RegistrationSection } from '../builders/registration_section_builder';
import { ScheduledSectionStatusServant } from '../servants/scheduled_section_status_servant';
import { IRegisterSectionsDatasource } from '../datasources/register_sections_datasource';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { UpdateSectionSelectionCommand } from '../../../components/section_selections/commands/update_section_selection_command';

export type MarkSelectedFlagForScheduledSectionsCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .service(
    'markSelectedFlagForScheduledSectionsCommand',
    (
      $q: ng.IQService,
      defineCommandORM: IDefineCommand,
      ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
      ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
      ngSectionsDatasource: ISectionsDatasource,
      ngTermScheduleFlags: TermScheduleFlags,
      updateSectionSelectionsCommand: UpdateSectionSelectionCommand
    ) => {
      return defineCommandORM('markSelectedFlagForScheduledSectionsCommand', (deferred) => {
        const sectionsWithStatus = ngSectionsDatasource
          .values()
          .filter((section) => !ngScheduledSectionStatusServant.isStatusUnscheduled(section));
        const allSectionsWithMeta = ngSectionsDatasource.metasource().composes(sectionsWithStatus);

        const regSections = allSectionsWithMeta.map((section) => {
          const isSectionSelected = ScheduledSectionServant.canBeSelected(section, ngTermScheduleFlags);
          section.is_selected = isSectionSelected;
          return section as RegistrationSection;
        });

        ngRegisterSectionsDatasource.write(regSections);
        const updateSectionSelectionPromises = regSections.map((section) =>
          updateSectionSelectionsCommand(section.id, section.is_selected)
        );
        $q.all(updateSectionSelectionPromises).then(deferred.resolve);
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/commands/mark_selected_flag_for_scheduled_sections_command.ts